import React from 'react';
import { AlertOctagon, RefreshCcw } from 'lucide-react';
import { Button } from './ui/button';

/**
 * ErrorBoundary component
 * Built with standard HTML + Tailwind + shadcn Button.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6 text-center max-w-2xl mx-auto">
          <div className="mb-6 rounded-full bg-destructive/10 p-4 inline-block">
            <AlertOctagon className="h-12 w-12 text-destructive" />
          </div>

          <h1 className="text-3xl font-bold tracking-tight text-foreground mb-4">
            Oops! Something went wrong.
          </h1>

          <p className="text-lg text-muted-foreground mb-8 text-balance">
            {this.state.error?.message || 'An unexpected error occurred our engineers have been notified.'}
          </p>

          {import.meta.env.DEV && this.state.errorInfo && (
            <div className="w-full text-left bg-muted p-4 rounded-lg border border-border mb-8 overflow-auto max-h-[400px]">
              <p className="text-sm font-semibold text-foreground mb-2 flex items-center gap-2">
                Stack Trace:
              </p>
              <pre className="text-[12px] font-mono whitespace-pre-wrap text-foreground opacity-80 leading-relaxed font-mono">
                {this.state.errorInfo.componentStack}
              </pre>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              size="lg"
              className="px-8"
              onClick={this.handleReload}
            >
              <RefreshCcw className="mr-2 h-4 w-4" />
              Reload Page
            </Button>
            <Button
              variant="outline"
              size="lg"
              className="px-8"
              onClick={() => window.location.href = '/'}
            >
              Go to Homepage
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;